import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {Paragraph} from '../Paragraph'
import {withPrefix} from 'gatsby-link'

import './endorsement.css'

class Endorsement extends Component {

  render () {
    let imgSrc = this.props.imgSrc;
    let name = this.props.name;
    let title = this.props.title;
    let text = this.props.text;

    return (
      <div className = "clearfix">
        <img className = "endorsement-img" src={withPrefix(imgSrc)}/>
        <div className = "endorsement-info">
          <div className = "endorsement-id">
            {name} | {title}
          </div>
          <div className = "endorsement-text">
            {text}
          </div>
        </div>
      </div>
    );
  }
}


export default {Endorsement}



// WEBPACK FOOTER //
// ./src/components/Endorsement/index.js